var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner",class:{ spinnerSm: _vm.size === 'small', spinnerDark: _vm.color === 'dark' }},_vm._l((12),function(i){return _c('div')}),0)}
var staticRenderFns = []

export { render, staticRenderFns }